import { render, staticRenderFns } from "./PipelineCRM.vue?vue&type=template&id=2ef235f2&scoped=true"
import script from "./PipelineCRM.vue?vue&type=script&lang=js"
export * from "./PipelineCRM.vue?vue&type=script&lang=js"
import style0 from "./PipelineCRM.vue?vue&type=style&index=0&id=2ef235f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef235f2",
  null
  
)

export default component.exports